import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_REGION,
  DELETE_REGION,
  GET_REGIONS,
  UPDATE_REGION,
  UPDATE_REGION_STATUS
} from "./actionTypes";

import {
  addRegionFail,
  addRegionSuccess,
  deleteRegionFail,
  deleteRegionSuccess,
  getRegionsFail,
  getRegionsSuccess,
  setState,
  updateRegionFail,
  updateRegionSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { dipiRegions, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchRegions({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, dipiRegions, params.toString());
    yield put(setState(false));
    yield put(getRegionsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getRegionsFail(error));
  }
}

function* updateRegion({ payload: regionObj }) {
  try {
    const { id, recordStatus, ...rest } = regionObj;
    yield call(patchApiCall, `${dipiRegions}/${id}`, rest);
    const response = yield call(getTable, `${dipiRegions}/${regionObj.id}`);
    yield put(updateRegionSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateRegionFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateRegionStatus({ payload: regionObj }) {
  try {
    const { id } = regionObj;
    yield call(patchApiCall, `${dipiRegions}/${updateStatus}/${id}`, { recordStatus: regionObj.recordStatus });
    const response = yield call(getTable, `${dipiRegions}/${regionObj.id}`);
    yield put(updateRegionSuccess(response));
  } catch (error) {
    yield put(updateRegionFail(error));
  }
}

function* deleteRegion({ payload: regionObj }) {
  try {
    yield call(deleteApiCall, `${dipiRegions}/${regionObj.id}`);
    yield put(deleteRegionSuccess(regionObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteRegionFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingRegion({ payload: region }) {
  try {
    const response = yield call(postApiCall, dipiRegions, region);
    yield put(addRegionSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addRegionFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* regionsSaga() {
  yield takeEvery(GET_REGIONS, fetchRegions);
  yield takeEvery(ADD_NEW_REGION, postingRegion);
  yield takeEvery(UPDATE_REGION, updateRegion);
  yield takeEvery(UPDATE_REGION_STATUS, updateRegionStatus);
  yield takeEvery(DELETE_REGION, deleteRegion);
}

export default regionsSaga;
